import { updateOnboardingLocationApi as generatedUpdateOnboardingLocationApi } from '../generated/onboarding/updateOnboardingLocation';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const updateOnboardingLocationApi = generatedUpdateOnboardingLocationApi.enhanceEndpoints({
  endpoints: {
    updateOnboardingLocation: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            draft.location = {
              ...draft.location,
              ...body,
            };

            if (draft.progress != null) {
              draft.progress.location = true;
            } else {
              draft.progress = { location: true };
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useUpdateOnboardingLocationMutation } = updateOnboardingLocationApi;
